import { useTranslation } from '@lyearn/i18n';
import { ArrowRightFill } from '@lyearn/icons';
import { Button, Stack } from '@lyearn/ui';
import { useCourseQuizNextLesson } from '@/modules/corporate/modules/course/components/QuizCardContainer/hooks/useCourseQuizNextLesson';

const NextLessonButton: React.FC = () => {
  const { t } = useTranslation();
  const { onNextLessonClick, isNextLessonAvailable } = useCourseQuizNextLesson();

  if (!isNextLessonAvailable) {
    return null;
  }

  return (
    <Stack className="px-16 pt-40 pb-34 border-t border-border w-full bg-bg-primary mt-auto absolute bottom-96">
      <Button
        EndIcon={ArrowRightFill}
        appearance="secondary"
        className="xs:flex xs:flex-1 !heading-s"
        shape="pill"
        size="x-large"
        variant="filled"
        onClick={onNextLessonClick}>
        {t('Course:Lesson.NextLesson')}
      </Button>
    </Stack>
  );
};

export default NextLessonButton;
